export default {
  name: 'ConfirmationModal',
  components: {
  },
  props: {
    confirmationTitle: '',
    showConfirmationModal: false,
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    confirm() {
      this.$emit('confirmAction');
    },
  },
};
